import { ImageCatalog } from "../../shared/constants";
import { mereReality, mereRealityCover } from "./mereReality/mereReality";

export interface Book {
  name: string;
  showCover: () => HTMLImageElement;
  show: (goBack: () => void) => void;
}

export const BOOKS: Book[] = [
  {
    name: 'mereReality',
    showCover: mereRealityCover,
    show: mereReality,
  },
] as const;

export const BOOKS_IMAGES: ImageCatalog = {
  mereRealityCover: {
    path: new URL('../../assets/images/books/bookCovers/mereRealityCover.jpg', import.meta.url),
    alt: 'Cardboard sketchbook with black banner reading Mere Reality',
  },
  sketchDiaryCover: {
    path: new URL('../../assets/images/books/bookCovers/mySketchDiaryCover.jpg', import.meta.url),
    alt: 'Cardboard sketchbook with white banner reading "My rainbow sketch diary" in many colors',
  },
} as const;
